module.exports = __webpack_public_path__ + "static/media/betting-history.05f0df05.svg";